<template>
  <div class="pravo">
    <div class="game-controls">
      <Time v-on:timeFinished="$emit('next-round')"/>
      <Rounds/>
    </div>
    <PravoTop
      Image="gameOverview"
      :Header="this.gameName"
    />
    <div class="charts">
      <SelectConfiguration/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import Rounds from "@/components/game/controls/Rounds.vue";
import Time from "@/components/game/controls/Time.vue";
import SelectConfiguration from "@/components/gameManager/charts/SelectConfiguration";

export default {
  name: 'gameChartsManager',
  components: {
    SelectConfiguration,
    PravoTop,
    Rounds,
    Time
  },
  data: function () {
    return {
      gameName: "Charts"
    };
  },
  computed: {
    ...mapGetters(['activeGame']),
  },
  async mounted() {
    if (this.activeGame != null) {
      this.gameName = "Charts - " + this.activeGame.name;
    }
  }
}
</script>

<style>
</style>
